import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroAgentesExtraccionService {
  private readonly agentesExtraccionUrl: string;

  constructor(private httpClient: HttpClient) {
    this.agentesExtraccionUrl = environment.apiUrl + '/administrador/agentes-extraccion/total'
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.agentesExtraccionUrl);
  }
}
